export type OperationTriggerType = 'Completion' | 'Scheduled' | 'Threshold'

export type OperationTriggerAction =
  | 'Create task'
  | 'Create workflow'
  | 'Raise issue'
  | 'Notify role'

export type OperationTriggerPriority = 'normal' | 'high' | 'critical'

export const TRIGGER_MODE_COLORS: Record<OperationTriggerType, string> = {
  Completion: '#24D07B',
  Scheduled: '#FF9900',
  Threshold: '#E74C3C',
}

export interface IOperationTriggerRow {
  id: number
  type: OperationTriggerType
  title: string
  priority: OperationTriggerPriority
  siteId?: number
  departmentId?: number
  action: OperationTriggerAction
  fireCount: number
  lastFired: string | null
  active: boolean
}
